import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import { playerReducer } from "../../../storage/reducers";
import FragmentSummary from "./fragment-summary";
import PatResultType from "../enums/pat-result-type";

export default class PatBlocked extends Fragment {
    constructor(blockedBy) {
        super();
        this.result = PatResultType.BLOCKED.code;
        this.blockedBy = blockedBy;

        this.requiredData = [
            {
                name: "blockedBy",
                type: FragmentDataType.Player,
                displayName: "Blocked by",
                appliesToOpponent: () => true,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            }
        ];
    }

    getPlayers() {
        return [this.blockedBy];
    }

    summarize(summaryContext, stringifier) {
        const message = ` was blocked by ${stringifier.firstInitial(
            this.blockedBy
        )}`;

        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            blockedBy: playerReducer(this.blockedBy)
        };
    }
}
